
<div mat-dialog-title class="titlePanel">
    <label>Buscar por:</label> 
</div>
<div mat-dialog-content class="">
  <form [formGroup]="form" fxLayout="column" xLayoutAlign="space-around none" >
    <div *ngIf="isAvailabilityFilter">
      <div class="row">
        <div>Fecha de disponibilidad</div>
        <div style="display: flex; flex-direction: column;">
          <div class="col-12 date-container">
            <mat-form-field appearance="fill" color="accent" class="calendar"  style="width: 100%;">
              <input matInput [matDatepicker]="picker" (click)="picker.open()" (dateInput)="limteFecha($event)" formControlName="initialDate" placeholder="Fecha Inicial">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-12 date-container">
            <mat-form-field appearance="fill" color="accent" class="calendar" style="width: 100%;">
              <input matInput [matDatepicker]="picker2" (click)="picker2.open()" formControlName="finalDate" placeholder="Fecha Final" [min]="min">
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="row">
        <div>Seleccionar Categorias</div>
        <div class="col-12">
          <mat-form-field style="width: 100%;">
            <mat-label>Categorias</mat-label>
            <mat-select formControlName="categories" placeholder="Seleccionar Categorias" multiple panelClass="filterCategoriesColumnsPanel">
              <mat-option *ngFor="let category of categoriesList" [value]="category.id">
                {{ category.shortName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="filter-flex">
      <div *ngFor="let filter of filters" style="display: flex; flex-direction: column;">
        <label >{{filter.key}}</label>
        <app-filter-map-autocomplete class="filter-item col-12"
        [filter]="filter"
        [selected]="filter.selected" 
        [form] = "form"
        (onOptionSelected)="addFilter($event)"
        (onOptionDeleted)="dropFilter($event)">
      </app-filter-map-autocomplete>
      </div>
    </div>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cerrar</button>
  <button mat-button *ngIf="!isAvailabilityFilter && valuesFiltered.length > 0" (click)="clear()">Limpiar</button>
  <button mat-button *ngIf="isAvailabilityFilter && selectedFinalDate != null" (click)="clear()">Limpiar</button>
  <button mat-button (click)="accept()" class="btnAccept">Buscar</button>
</div>
